module.exports =
  ENV: 'staging'
  baseApiUrl: 'https://api.staging.salony.com'
